import { render, staticRenderFns } from "./PhysicalExerciseCreateForm.vue?vue&type=template&id=5b37bb73&scoped=true&"
import script from "./PhysicalExerciseCreateForm.vue?vue&type=script&lang=ts&"
export * from "./PhysicalExerciseCreateForm.vue?vue&type=script&lang=ts&"
import style0 from "./PhysicalExerciseCreateForm.vue?vue&type=style&index=0&id=5b37bb73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37bb73",
  null
  
)

export default component.exports